








































import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import Permission from '@/modules/authorization/model/Permission';
import AuthorizationItemTree from '@/modules/authorization/components/AuthorizationItemTree.vue';
import {State} from 'vuex-class';

/**
 * Campo de selección de permisos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {AuthorizationItemTree},
})
export default class PermissionSelect extends Vue {
    @Prop({type: String, default: 'Seleccionar permiso'})
    public label: string

    /**
     * Ruta del permiso actualmente seleccionado
     */
    @Prop({type: String, default: ''})
    public value: string

    @Prop({type: Boolean, default: false})
    public disabled: boolean

    public items: Permission[] = []

    public selectDialog = false

    public active: Permission | null = null

    @State(state => state.authorization.permissions)
    public permissions: Permission

    public get isMobile () {
        return this.$vuetify.breakpoint.smAndDown
    }

    @Watch('value', {immediate: true})
    public valueChange (value: string) {
        if (!value) {
            this.items = []
            this.active = null

            return
        }

        const permission = this.permissions.findByPath(value) as Permission
        if (!permission) {
            throw new Error(`El permiso con la ruta ${value} no existe en el árbol`)
        }

        this.items = [permission]
        this.active = permission
    }

    public selectPermission (path: string) {
        this.selectDialog = false
        const permission = this.permissions.findByPath(path) as Permission
        if (!permission) {
            throw new Error(`El permiso con la ruta ${path} no existe en el árbol`)
        }

        this.items = [permission]
        this.active = permission

        this.$emit('input', permission)
    }
}
